<div class="ui-g" *ngIf="multiple==false">
    <div class="ui-g-12">
        <div class="p-field p-grid">
            <div class="p-col">
                <p-dropdown class="notranslate" [(ngModel)]="to_user_guid" [options]="doctor_list" [filter]="true" name="doctors"
                    (ngModelChange)="sendGuid()" #doctors="ngModel" required defaultLabel="Select a Doctor"
                    [disabled]="doctorsListing_posting">
                </p-dropdown>

                <div *ngIf="doctors.invalid && (doctors.dirty || doctors.touched)" class="alert alert-danger">
                    <div *ngIf="doctors.errors.required">
                        Choose a doctor.
                    </div>

                </div>
                <div class="ui-g-12" style="float: right;">

                    <div class="ui-g-12">
                        <div class="p-field-checkbox">
                            <p-checkbox [(ngModel)]="is_filter" binary="true" inputId="binary"
                                (ngModelChange)="CallCountryAndSpecialtyFn()" name="filter"
                                [disabled]="doctorsListing_posting"></p-checkbox>
                            <label for="binary" style="margin-left: 2%;">Filter by Country or Specialty?</label>
                        </div>
                    </div>
                </div>
                <div *ngIf="this.is_filter">
                    <div class="ui-g-12" style="float: right;">
                        <div class="ui-g-12">Country : </div>
                        <div class="ui-g-12">
                            <p-dropdown class="notranslate" [(ngModel)]="param.country_id" [options]="countries" [filter]="true"
                                (ngModelChange)="GetDoctors()" name="countriesModel" #countriesModel="ngModel"
                                placeholder="Select a Country" [disabled]="doctorsListing_posting || !this.is_filter">
                            </p-dropdown>
                        </div>
                    </div>
                    <div class="ui-g-12" style="float: right;">
                        <div class="ui-g-12">Specialty : </div>
                        <div class="ui-g-12">
                            <p-dropdown class="notranslate" [(ngModel)]="param.specialty_id" [options]="specialties" [filter]="true"
                                (ngModelChange)="GetDoctors()" name="specialtiesModel" #specialtiesModel="ngModel"
                                placeholder="Select a Specialty" [disabled]="doctorsListing_posting || !this.is_filter">
                            </p-dropdown>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="ui-g" *ngIf="multiple==true">
    <div class="ui-g-12">
        <div class="p-field p-grid">
            <div class="p-col">
                <p-multiSelect class="notranslate" [(ngModel)]="to_user_guid" [options]="doctor_list" [filter]="true" name="doctors"
                    (ngModelChange)="sendGuid()" #doctors="ngModel" required [disabled]="doctorsListing_posting">
                </p-multiSelect>

                <div *ngIf="doctors.invalid && (doctors.dirty || doctors.touched)" class="alert alert-danger">
                    <div *ngIf="doctors.errors.required">
                        Choose a doctor(s).
                    </div>

                </div>
                <div class="ui-g-12" style="float: right;">

                    <div class="ui-g-12">
                        <div class="p-field-checkbox">
                            <p-checkbox [(ngModel)]="is_filter" binary="true" inputId="binary"
                                (ngModelChange)="CallCountryAndSpecialtyFn()" name="filter"
                                [disabled]="doctorsListing_posting"></p-checkbox>
                            <label for="binary" style="margin-left: 2%;">Filter by Country or Specialty?</label>
                        </div>
                    </div>
                </div>
                <div *ngIf="this.is_filter">
                    <div class="ui-g-12" style="float: right;">
                        <div class="ui-g-12">Country : </div>
                        <div class="ui-g-12">
                            <p-dropdown class="notranslate" [(ngModel)]="param.country_id" [options]="countries" [filter]="true"
                                (ngModelChange)="GetDoctors()" name="countriesModel" #countriesModel="ngModel"
                                placeholder="Select a Country" [disabled]="doctorsListing_posting || !this.is_filter">
                            </p-dropdown>
                        </div>
                    </div>
                    <div class="ui-g-12" style="float: right;">
                        <div class="ui-g-12">Specialty : </div>
                        <div class="ui-g-12">
                            <p-dropdown class="notranslate" [(ngModel)]="param.specialty_id" [options]="specialties" [filter]="true"
                                (ngModelChange)="GetDoctors()" name="specialtiesModel" #specialtiesModel="ngModel"
                                placeholder="Select a Specialty" [disabled]="doctorsListing_posting || !this.is_filter">
                            </p-dropdown>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="doctorsListing_response.success!=null && doctorsListing_response.success==false" class="alert alert-danger">
    <p *ngIf="doctorsListing_response.error!=null">{{doctorsListing_response.error.message}}</p>
    <div *ngIf="doctorsListing_serverError!=null">
        <div *ngIf="doctorsListing_serverError.error!=null && doctorsListing_serverError.statusCode!=500">
            <p *ngFor="let message of doctorsListing_serverError.message">{{message}}</p>
        </div>
        <div *ngIf="doctorsListing_serverError.error!=null && doctorsListing_serverError.statusCode===500">
            <p>{{doctorsListing_serverError.message}}</p>
        </div>
    </div>


</div>